import React, { useState,useEffect } from "react";
import { toast } from "react-hot-toast";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "./package.css";

const Catagories = () => {

  const [title, setTitle] = useState("");
  const [id, setId] = useState("");
  const [temp, setTemp] = useState("");
  const [cat, setCat] = useState([]);

  const name = localStorage.getItem("@^&*$£%$!##%admin@^&*$£%$!##%");
  const db = firebase.firestore();
  const itemsRef = db.collection("catagories");

  useEffect(() => {
    loadCat()
  }, []);

  const loadCat = async () => {
    const dataArray = [];
    const db = firebase.firestore();
    db.collection("catagories").get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          dataArray.push({ id: doc.id, ...doc.data() });
        });
        setCat(dataArray);
      });
  }

  const create = async (e) => {
    try {
      if (!title) {
        return toast.error("Title is Required");
      }
      /**  */
      const query = itemsRef.where("title", "==", title);
      query.get().then((querySnapshot) => {
        if (querySnapshot.size > 0) {
          // eslint-disable-next-line
          const doc = querySnapshot.docs[0];
          toast.error("Title Already in Use");
          return;
        } else {
          itemsRef
            .add({
              title,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then((docRef) => {
              toast.success("Catagory Added");
              loadCat();
              setTitle("");
            })
            .catch((error) => {
              toast.error("Error in Adding New Catagory");
            });
        }
      });
    } catch (error) {
      console.log(error);
      toast.error("Something went Wrong");
    }
  };

  const read = async (e) => {
    e.preventDefault();
    if (!title) {
      return toast.error("Title is Required");
    }
    const query = itemsRef.where("title", "==", title);
    query
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.size > 0) {
          querySnapshot.forEach((doc) => {
            setTitle(title);
            setTemp(title);
            setId(doc.id);
            toast.success("Catagory Founded");
          });
        } else {
          toast.error("Catagory Not Foound");
        }
      })
      .catch((error) => {
        toast.error("Error Getting Catagory ");
      });
  };

  const update = async (e) => {
    e.preventDefault();
    if (!title) {
      return toast.error("Please Enter Title and Click on Get Catagory");
    }
    if (id === "") {
      return toast.error("Click on Get Catagory");
    }

    try {
      if (temp === title) {
        const docRef = itemsRef.doc(id);
        docRef
          .update({
            title,
          })
          .then((data) => {
            toast.success("Catagory Updated Successfully");
            setTitle("");
            loadCat();
          })
          .catch((error) => {
            toast.error("Error in Updating Catagory");
          });
      } else {
        const query = itemsRef.where("title", "==", title);
        query.get().then((querySnapshot) => {
          if (querySnapshot.size > 0) {
            // eslint-disable-next-line
            const doc = querySnapshot.docs[0];
            toast.error("Title Already in Use");
            return;
          } else {
            const docRef = itemsRef.doc(id);
            docRef
              .update({
                title,
              })
              .then((data) => {
                toast.success("Catagory Updated Successfully");
                setTitle("");
                loadCat();
              })
              .catch((error) => {
                toast.error("Error in Updating Catagory");
              });
          }
        });
      }
    } catch (error) {
      toast.error("Something went Wrong");
    }
  };
  const deletee = async (e) => {
    e.preventDefault();
    if (!title) {
      return toast.error("Please Enter Title and Click on Get Catagory");
    }
    if (id === "") {
      return toast.error("Click on Get Catagory");
    }
    try {
      const docRef = itemsRef.doc(id);
      docRef
        .delete()
        .then((data) => {
          toast.success("Catagory Deleted Successfully");
          setTitle("");
          loadCat();
        })
        .catch((error) => {
          toast.error("Catagory not Deleted");
        });
    } catch (error) {
      toast.error("Something went Wrong");
    }
  };

  return (
    <div className="p-main">
      <h2>Admin {name}</h2>
        <div className="a-main mt-2">
            <div className="p-main">
                <h4 className="mt-3">Catagories List</h4>
                {cat !== ""
                ? cat.map((p, i) =>
                      <div className="cat">
                        <h5>{i+1 +'. '  + p.title}</h5>
                      </div>
                )
                : <h4>"No Products"</h4>}

                <input
              type="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="form-control"
              placeholder="Title "
              required
              autoFocus
                />
                <div className="mb-3 bbtn">
                    <button onClick={create}>Add Catagory</button>
                    <button onClick={read}>Get Catagory</button>
                    <button onClick={update}>Update Catagory</button>
                    <button onClick={deletee} className=" mt-2">
                        Delete Catagory
                    </button>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Catagories;